export const captureUTMs = () => {
  if (typeof window === 'undefined') return

  const params = new URLSearchParams(window.location.search)
  const utmKeys = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_content',
    'utm_term',
  ]
  let hasUtms = false
  const utmData: Record<string, string> = {}

  utmKeys.forEach((key) => {
    if (params.has(key)) {
      utmData[key] = params.get(key)!
      hasUtms = true
    }
  })

  if (hasUtms) {
    sessionStorage.setItem('meta_utms', JSON.stringify(utmData))
  }
}

export const trackPurchase = async () => {
  if (typeof window === 'undefined') return

  // 1. Generar Event ID único para deduplicación
  const eventId =
    'evt_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9)
  const timestamp = Math.floor(Date.now() / 1000)
  const currentUrl = window.location.href
  const userAgent = navigator.userAgent

  // 2. Recuperar UTMs guardadas
  const storedUtms = sessionStorage.getItem('meta_utms')
  const utms = storedUtms ? JSON.parse(storedUtms) : {}

  // 3. Disparar evento Frontend (Pixel)
  if (window.fbq) {
    window.fbq(
      'track',
      'Purchase',
      {
        value: 22000,
        currency: 'ARS',
        ...utms,
      },
      { eventID: eventId },
    )
    console.log('Pixel Purchase disparado', eventId)
  }

  // 4. Obtener IP del cliente (necesario para CAPI)
  let clientIp = ''
  try {
    const ipRes = await fetch('https://api.ipify.org?format=json')
    const ipData = await ipRes.json()
    clientIp = ipData.ip
  } catch (e) {
    console.warn('No se pudo obtener la IP del cliente')
  }

  // 5. Disparar evento Backend (Conversion API)
  const pixelId = '958699360076044'
  const accessToken =
    'EAANHnNddnAIBRb8tfSNlcbfRn2gypFjJLGKRKAt2vLuG85gcFtQvslI8ZCIZCVcZBeDBEP4yPN8jLG2OZAfAl8fU0FvpaH7u5Ptd4ZB7BjEg9N9XlBUgR5ffSSRzZAQDGknVwLhOf59XSHZCGeDDiozoc8s5Kpjrc0gM5iYh1kr0rIiUuffZAuyf5wZBCC1UaZBQZDZD'

  const payload = {
    data: [
      {
        event_name: 'Purchase',
        event_time: timestamp,
        action_source: 'website',
        event_source_url: currentUrl,
        event_id: eventId,
        user_data: {
          client_ip_address: clientIp,
          client_user_agent: userAgent,
        },
        custom_data: {
          currency: 'ARS',
          value: 22000,
          ...utms,
        },
      },
    ],
    access_token: accessToken,
  }

  try {
    const response = await fetch(
      `https://graph.facebook.com/v18.0/${pixelId}/events`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      },
    )

    const result = await response.json()
    console.log('CAPI Purchase enviado:', result)
  } catch (error) {
    console.error('Error enviando evento CAPI:', error)
  }
}
